
import {defineComponent} from 'vue'
import {mapGetters} from 'vuex'
import YieldFormNew from '../../components/form/bond/YieldFormNew.vue'

export default defineComponent({
  name: 'YieldCheckNewDash',
  components: {
    YieldFormNew
  },
  computed: {
    ...mapGetters([
      'isStaff'
    ])
  }
});
